import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { SlideInOutAnimation } from "../../modules/animationModule/animationModule";
import { ConfigurationService } from "../../shared/configuration.service";
import packageInfo from "../../../../package.json";
const version = packageInfo.version;

@Component({
  selector: "app-welcome",
  templateUrl: "./welcome.component.html",
  styleUrls: ["./welcome.component.css"],
  providers: [ConfigurationService],
  animations: [SlideInOutAnimation],
})
export class WelcomeComponent {
  public version: string = version;

  animationState = "in";
  constructor(private router: Router, private config: ConfigurationService) {}

  navigate(url: string): void {
    this.animationState = this.animationState === "out" ? "in" : "out";
    setTimeout(() => {
      this.router.navigateByUrl(url);
    }, this.config.configuration.animatedNavigationTimeout);
  }
}
